import { i18nTranslationHelper } from '@/i18n'

const t = i18nTranslationHelper.getTEnums

export namespace CareerMoment {
  export class Enum {
    static readonly STARTING = new Enum(
      'STARTING',
      t('careerMoment.STARTING.title'),
      t('careerMoment.STARTING.description'),
      '🚀'
    )

    static readonly EVOLVING = new Enum(
      'EVOLVING',
      t('careerMoment.EVOLVING.title'),
      t('careerMoment.EVOLVING.description'),
      '🌟'
    )

    static readonly TRANSITIONING = new Enum(
      'TRANSITIONING',
      t('careerMoment.TRANSITIONING.title'),
      t('careerMoment.TRANSITIONING.description'),
      '🧭'
    )

    public constructor(
      public readonly name: string,
      public readonly title: string,
      public readonly description: string,
      public readonly icon: string
    ) {}
  }

  export const getAll = (): Enum[] => Object.values(Enum)

  export const getByName = (name: string | null): Enum =>
    name && Object.values(Enum).find(type => type.name === name)
}
